import { createApi } from '@reduxjs/toolkit/query/react';

import { serviceUrl } from '../utils/apiConfig';

import customBaseQuery from './customBaseQuery';

const api = createApi({
  baseQuery: customBaseQuery({
    baseUrl: serviceUrl
  }),
  tagTypes: [
    'IsUnderReview',
    'AssignedTests',
    'ScheduleTests',
    'GetAllAdmins',
    'GetAllStudentAudits',
    'GetAllTags',
    'StudentScheduleTests',
    'UserTests'
  ],
  endpoints: () => ({})
});

export default api;
